module.exports = require("@pandora/data-model-contract");